const DEFAULT_LOCAL_API = 'http://localhost:3000';
const API_PORT = process.env.REACT_APP_API_PORT || '3000';

function normalizeBase(url) {
  if (!url) return '';
  return String(url).replace(/\/+$/, '');
}

function isLocalHost(hostname) {
  return !hostname || hostname === 'localhost' || hostname === '127.0.0.1';
}

function hostFromUrl(base) {
  try {
    return new URL(base).hostname;
  } catch {
    return '';
  }
}

/**
 * API origin for fetch calls.
 *
 * Priority:
 * 1. REACT_APP_API_BASE when set (e.g. http://54.167.31.169:3000 or PUBLIC_API_URL)
 * 2. Same host:API_PORT when UI is remote
 * 3. localhost:3000 for local UI with no config
 *
 * Set REACT_APP_API_BASE=http://localhost:3000 to force local backend (Goals dev).
 * Set REACT_APP_API_BASE=http://54.167.31.169:3000 to see live Tasks from local UI.
 */
export function resolveApiBase() {
  const configured = normalizeBase(process.env.REACT_APP_API_BASE || '');

  if (typeof window !== 'undefined' && window.location?.hostname) {
    const { protocol, hostname } = window.location;
    const remoteUi = !isLocalHost(hostname);

    if (configured) {
      // Don't let a laptop-only URL leak into a remote deployment.
      if (remoteUi && isLocalHost(hostFromUrl(configured))) {
        return `${protocol}//${hostname}:${API_PORT}`;
      }
      return configured;
    }

    if (remoteUi) {
      return `${protocol}//${hostname}:${API_PORT}`;
    }
    return DEFAULT_LOCAL_API;
  }

  return configured || DEFAULT_LOCAL_API;
}
